import * as Yup from 'yup';
import { Form } from '@/components';
import { useField } from 'formik';
import { UpdateTermsAndConditionsArgs } from '@/redux/termsAndConditions';
import { isRichTextEmpty } from '@/utils';

interface Props {
  initialValue?: UpdateTermsAndConditionsArgs;
  onSubmit: (value: UpdateTermsAndConditionsArgs) => any;
}

const schema = Yup.object().shape({
  content: Yup.string()
    .test(
      'richTextRequired',
      { key: 'mixed.required' },
      (value) => !isRichTextEmpty(value),
    )
    .required(),
  attachmentIds: Yup.array()
    .of(Yup.string().nullable().required())
    .nullable()
    .defined(),
});

const DEFAULT_VALUE: UpdateTermsAndConditionsArgs = {
  content: '',
  attachmentIds: [],
  version: 0,
};

export function TermsAndConditionsEditPanel(props: Props) {
  const { initialValue, onSubmit } = props;

  const value = initialValue ?? DEFAULT_VALUE;

  return (
    <Form.Formik<UpdateTermsAndConditionsArgs>
      uid="terms-and-conditions"
      i18n="termsAndConditions.details"
      initialValues={{ ...value, attachmentIds: [] }}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <div>
        <FormRichText name="content" attachmentName="attachmentIds" />
      </div>
    </Form.Formik>
  );
}

function FormRichText({
  name,
  attachmentName,
}: {
  name: string;
  attachmentName: string;
}) {
  const [, , { setValue }] = useField(attachmentName);
  return (
    <Form.RichTextEditor
      name={name}
      required
      setAttachmentIds={setValue}
      ownerType="TermsAndConditions"
      ownerId=""
    />
  );
}
